import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Companies from "./Companies";
import LoginModal from "./LoginModal";
import TermsOfUse from "./legal/TermsOfUse";
import KvkkPrivacyPolicy from "./legal/KvkkPrivacyPolicy";
import AydinlatmaMetni from "./legal/AydinlatmaMetni";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("superadmin_token");
  if (!token) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <Router>
      <Routes>
        {/* SuperAdmin Login */}
        <Route path="/" element={<LoginModal />} />

        {/* SuperAdmin Companies */}
        <Route
          path="/:userId/companies"
          element={
            <ProtectedRoute>
              <Companies />
            </ProtectedRoute>
          }
        />

        {/* Legal */}
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/kvkk-privacy" element={<KvkkPrivacyPolicy />} />
        <Route path="/aydinlatma-metni" element={<AydinlatmaMetni />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
